import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconCopyLink = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_4339_2627)">
      <path
        d="M10.6667 10.6667V12.5334C10.6667 13.2801 10.6667 13.6535 10.5213 13.9387C10.3935 14.1896 10.1895 14.3936 9.93865 14.5214C9.65343 14.6667 9.28006 14.6667 8.53333 14.6667H3.46666C2.71992 14.6667 2.34656 14.6667 2.06134 14.5214C1.81046 14.3936 1.60648 14.1896 1.47865 13.9387C1.33333 13.6535 1.33333 13.2801 1.33333 12.5334V7.46671C1.33333 6.71997 1.33333 6.3466 1.47865 6.06139C1.60648 5.8105 1.81046 5.60653 2.06134 5.4787C2.34656 5.33337 2.71992 5.33337 3.46666 5.33337H5.33333M7.46666 10.6667H12.5333C13.2801 10.6667 13.6534 10.6667 13.9386 10.5214C14.1895 10.3936 14.3935 10.1896 14.5213 9.93869C14.6667 9.65348 14.6667 9.28011 14.6667 8.53337V3.46671C14.6667 2.71997 14.6667 2.3466 14.5213 2.06139C14.3935 1.8105 14.1895 1.60653 13.9386 1.4787C13.6534 1.33337 13.2801 1.33337 12.5333 1.33337H7.46666C6.71992 1.33337 6.34656 1.33337 6.06134 1.4787C5.81046 1.60653 5.60648 1.8105 5.47865 2.06139C5.33333 2.3466 5.33333 2.71997 5.33333 3.46671V8.53337C5.33333 9.28011 5.33333 9.65348 5.47865 9.93869C5.60648 10.1896 5.81046 10.3936 6.06134 10.5214C6.34656 10.6667 6.71992 10.6667 7.46666 10.6667Z"
        stroke="#2B3F6C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_4339_2627">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)
